export default __webpack_public_path__ + "static/media/Xlog3D_Handbook.f70f4e16.pdf";